module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('form', {
    staticClass: "form-inline"
  }, [(_vm.errors.length > 0) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_c('ul', _vm._l((_vm.errors), function(error) {
    return _c('li', [_vm._v(_vm._s(error))])
  }))]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail != 1) ? _c('div', {
    staticClass: "input-group mr-sm-2 mb-sm-0"
  }, [_c('div', {
    staticClass: "input-group-addon"
  }, [_vm._v("@")]), _vm._v(" "), (_vm.verifiedEmail == -1) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "john.smith@gmail.com"
    },
    domProps: {
      "value": _vm._s(_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == 0) ? _c('span', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.verifyCode),
      expression: "verifyCode"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Verify Code"
    },
    domProps: {
      "value": _vm._s(_vm.verifyCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.verifyCode = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isValid,
      "value": "send"
    },
    on: {
      "click": function($event) {
        _vm.verify()
      }
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v("\n            Verify " + _vm._s(_vm.email) + "\n          ")])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == 1) ? _c('span', [_vm._v("\n          " + _vm._s(_vm.email) + " (verified)\n      ")]) : _vm._e(), _vm._v(" "), (_vm.verifiedEmail == -1) ? _c('button', {
    staticClass: "btn btn-primary",
    attrs: {
      "disabled": !_vm.isValid,
      "value": "send"
    },
    on: {
      "click": function($event) {
        _vm.createOrVerify()
      }
    }
  }, [(_vm.loading) ? _c('i', {
    staticClass: "fa fa-spin fa-spinner"
  }) : _vm._e(), _vm._v("\n    Verify Your Email\n  ")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2be2abf5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Verify.vue
// module id = 81
// module chunks = 2